module.exports = __webpack_public_path__ + "static/media/logo.d190a62b.svg";